import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as locatorActions from "../store/locator/actions";

const useGetServiceAreaByZip = (zip, countryCode) => {
  const zipCountry = [zip, countryCode].join("-");
  const serviceArea = useSelector(
    ({ locator }) =>
    locator.serviceAreas && locator.serviceAreas[zipCountry]
  );
  const [fetching, setFetching] = useState(false);
  const [fetchingError, setFetchingError] = useState(null);
  const dispatch = useDispatch();

  const dispatchGetServiceAreaByZip = useCallback(async () => {
    try {
      setFetching(true);
      if (zip && zip.length === 5) {
        setFetchingError(null)
        await dispatch(
          locatorActions.getServiceAreaByZip({ zip, countryCode })
        );
      }
    } catch (error) {
      setFetchingError(error.message);
    }
    setFetching(false);
  }, [zip, countryCode, dispatch]);

  return {
    serviceArea,
    dispatchGetServiceAreaByZip,
    fetching,
    fetchingError,
  };
};

export default useGetServiceAreaByZip;
